// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".CopyButton_copyButton__2w87x {\n  background-color: transparent;\n  border: 0;\n  padding: 4px 4px 4px 6px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  margin: 0 0 4px 4px;\n}\n\n.CopyButton_copyButton__2w87x:hover {\n  background-color: #e0e0e0;\n}\n\n.CopyButton_copyButton__2w87x:active {\n  background-color: #d0d0d0;\n}\n\n.CopyButton_copyButtonIcon__2MFJK {\n  font-size: 16px !important;\n}\n", ""]);
// Exports
exports.locals = {
	"copyButton": "CopyButton_copyButton__2w87x",
	"copyButtonIcon": "CopyButton_copyButtonIcon__2MFJK"
};
module.exports = exports;
